import { $taskMessageTemplateCategories, $taskMessageTemplates } from './states';
import { fetchTaskMessageTemplateCategories, fetchTaskMessageTemplates } from './effects';

// Fetch task message template categories
$taskMessageTemplateCategories.on(fetchTaskMessageTemplateCategories.doneData, (_, data) => data);

// Fetch task message templates
$taskMessageTemplates.on(fetchTaskMessageTemplates.doneData, (_, data) => data);
